import { Component, OnInit } from '@angular/core';
import { MrpScrolltopComponent } from '../services/mrp-scrolltop/mrp-scrolltop.component';
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';
import { VideoComponent } from '../video/video.component';
import { AudioLibraryComponent } from '../audio-library/audio-library.component';


@Component({
    selector: 'app-video-audio',
    templateUrl: './video-audio.component.html',
    styleUrls: ['./video-audio.component.css'],
    imports: [MrpScrolltopComponent, MatTabGroup, MatTab, MatTabContent, VideoComponent, AudioLibraryComponent]
})
export class VideoAudioComponent implements OnInit {

  title = 'Video Portal';
  selectedTabIndex: number = 0;

  constructor() { }

  ngOnInit(): void {
    this.selectedTabIndex = 0;
  }

  onTabChange(event: any): void {
    this.selectedTabIndex = event;   
  }

}
